
import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import Cookies from "js-cookie";
import { Box } from '@mui/system';
import { login } from './api';
import { AppDispatch } from '../../store';
import { useDispatch } from 'react-redux';
import { authenticateWithCredentials } from '../../store/AuthSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { setError } from '../../store/error.slice';
import { decodeJWT, getToken } from '../../utils/utils';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('Email:', email);
    console.log('Password:', password);
    console.log('Remember Me:', rememberMe);

    try {
      const action = await dispatch(
        authenticateWithCredentials({
          email: email,
          password: password,
        })
      );

      if (authenticateWithCredentials.fulfilled.match(action)) {
        // Get the token after successful authentication
        const token = getToken();
        console.log(token, "kkkkkkkksssssssssss");
        const decodedToken = decodeJWT(token);
        const userRole = decodedToken?.user_role_name?.toLowerCase();
        const acessdata = decodedToken?.access;
        console.log(userRole, "userRolesssssssss2222");
        console.log(acessdata, "ooooooodddddddddd");

        // Navigation logic based on user role and access
        if (userRole === "Team Member" || userRole === "team member" || userRole === "module owner" || userRole === "Module Owner") {
            
          if (acessdata.includes("Tasks Approval")) {
            navigate("/tasks-approval");
          } else if (acessdata.includes("Task")) {
            navigate("/manage-task");
          } else if (acessdata.includes("Reports")) {
            navigate("/reports/taskreports");
          } else if (acessdata.includes("Dashboard")) {
            navigate("/");
          } else if (acessdata.includes("Brands")) {
            navigate("/brands");
          }

        } 
  else if (userRole==="Admin"||userRole==="admin") {
    navigate("/tasks-approval");
  }

        dispatch(
          setError({
            message: "success",
            type: "success",
            time: new Date().toLocaleString(),
          })
        );
      } else {
        const errorMessage = (action.error.message as string) || "Unknown error";
        dispatch(
          setError({
            message: errorMessage,
            type: "error",
            time: new Date().toLocaleString(),
          })
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img src="/logo-pmi.png" alt='logo' />
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/forgot-password" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
